const sliderSections = document.querySelectorAll( ".slider-section" );

sliderSections.forEach( ( sliderSection ) => {
  const slider = tns( {
    container: sliderSection.querySelector( ".slider" ),
    items: 1,
    center: true,
    fixedWidth: 715,
    autoplay: true,
    controls: true,
    nav: false,
    loop: false,
    autoplayButtonOutput: false,
    controlsContainer: sliderSection.querySelector( ".slider-controls" ),
    speed: 400,
    gutter: 128,
    // edgePadding: -400,
    fixedHeight: true,
    responsive: {
      290: { items: 1, gutter: 40, fixedWidth: 335 },
      768: { items: 1, gutter: 50, fixedWidth: 450 },
      1024: { items: 1, gutter: 60, fixedWidth: 500 },
      1200: { items: 1, gutter: 60, fixedWidth: 715 },
      1600: { items: 1, gutter: 60, fixedWidth: 715 },
    },
  } );

  function updateCenterSlide () {
    // All original slides
    const slides = sliderSection.querySelectorAll( ".slider .slide" );
    slides.forEach( slide => slide.classList.remove( "highlight" ) );

    const info = slider.getInfo();
    const divisor = window.innerWidth >= 1200 ? 4 : 3;
    const centerIndex = ( info.index + Math.floor( info.items / divisor ) ) % slides.length;

    slides[ centerIndex ].classList.add( "highlight" );
  }

  updateCenterSlide();
  slider.events.on( "indexChanged", updateCenterSlide );
} );